import type { ComponentType } from "react";
import { AwaitingAcceptance } from "~/components/specifics/deals/[id]/statuses/AwaitingAcceptance";
import { Canceled } from "~/components/specifics/deals/[id]/statuses/Canceled";
import { Finished } from "~/components/specifics/deals/[id]/statuses/Finished";
import { InConstruction } from "~/components/specifics/deals/[id]/statuses/InConstruction";
import { InEstimation } from "~/components/specifics/deals/[id]/statuses/InEstimation";
import { NowAccepting } from "~/components/specifics/deals/[id]/statuses/NowAccepting";
import { OwnFinished } from "~/components/specifics/deals/[id]/statuses/OwnFinished";
import { OwnInConstruction } from "~/components/specifics/deals/[id]/statuses/OwnInConstruction";
import { OwnInEstimation } from "~/components/specifics/deals/[id]/statuses/OwnInEstimation";
import { PartiallyFinished } from "~/components/specifics/deals/[id]/statuses/PartiallyFinished";
import { SendEstimate } from "~/components/specifics/deals/[id]/statuses/SendEstimate";
import type { StatusId } from "~/models/Status";
import {
	AWAITING_ACCEPTANCE,
	CANCELED,
	FINISHED,
	IN_CONSTRUCTION,
	IN_ESTIMATION,
	NOW_ACCEPTING,
	OWN_AWAITING_ACCEPTANCE,
	OWN_FINISHED,
	OWN_IN_CONSTRUCTION,
	OWN_IN_ESTIMATION,
	OWN_SEND_ESTIMATE,
	PARTIALLY_FINISHED,
	SEND_ESTIMATE
} from "~/models/Status";
import { OwnAwaitingAcceptance } from "./OwnAwaitingAcceptance";
import { OwnSendEstimate } from "./OwnSendEstimate";

type Props = {
	statusId: StatusId;
};

type ComponentsType = Partial<Record<StatusId, ComponentType>>;

export function StatusSwitcher({ statusId }: Props) {
	const Components = {
		[NOW_ACCEPTING]: NowAccepting,
		[IN_ESTIMATION]: InEstimation,
		[SEND_ESTIMATE]: SendEstimate,
		[IN_CONSTRUCTION]: InConstruction,
		[AWAITING_ACCEPTANCE]: AwaitingAcceptance,
		[PARTIALLY_FINISHED]: PartiallyFinished,
		[FINISHED]: Finished,
		[OWN_IN_ESTIMATION]: OwnInEstimation,
		[OWN_SEND_ESTIMATE]: OwnSendEstimate,
		[OWN_IN_CONSTRUCTION]: OwnInConstruction,
		[OWN_AWAITING_ACCEPTANCE]: OwnAwaitingAcceptance,
		[OWN_FINISHED]: OwnFinished,
		[CANCELED]: Canceled
	} as const satisfies ComponentsType;
	const Component = Components[statusId];

	return <Component />;
}
